import React from 'react';
import LegalPage from './LegalPage';
import content from '../legal/terminosDeServicioContent';

export default function TerminosDeServicio() {
  return <LegalPage content={content} />;
}
